import { render } from "./2.LogosBanner.vue?vue&type=template&id=f1bf5430&scoped=true"
import script from "./2.LogosBanner.vue?vue&type=script&lang=js"
export * from "./2.LogosBanner.vue?vue&type=script&lang=js"

import "./2.LogosBanner.vue?vue&type=style&index=0&id=f1bf5430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bf5430"]])

export default __exports__